<template>
	<div>
		<HeroSection>
			<TwoColumns
				:has-padding-first-column="true"
				:first-column-class="'px-10 md:px-14 lg:pl-20 order-last lg:order-none'"
			>
				<template #first>
					<BreadcrumbNavigation :crumbs="crumbs" />

					<h1 class="mt-8">Car finance just got easier</h1>
					<div class="mt-8 text-lg text-gray-575">
						<div>
							Whether you're after a new car loan, used car loan
							or business car loan, we can help.
						</div>
					</div>
					<div class="mt-4 flex flex-col">
						<TickList
							:icon-top="'top-2'"
							:items="financingItems"
							class="text-lg text-gray-575"
						/>
					</div>
					<CarClarityCalculators />
				</template>
				<template #second>
					<div class="h-full">
						<div class="flex h-full items-center">
							<CarbarImage
								image="img/finance/hero-car-finance.webp"
								alt-text="Finance"
							/>
						</div>
					</div>
				</template>
			</TwoColumns>
		</HeroSection>

		<ContainedSection :has-background="true">
			<ImageAndContent
				:image-on-right="true"
				:image-on-top="false"
				:content-column-padding="'lg:pr-5 xl:pr-10'"
				:image-column-padding="'lg:pl-5 xl:pl-10'"
			>
				<template #content>
					<div>
						<h2 class="mt-0">
							Access some of Australia's most reputable car
							finance lenders
						</h2>
						<div class="mt-8 space-y-4 text-lg text-gray-575">
							If you're looking for new, demo or used car finance,
							you have come to the right place.
						</div>
						<div class="mt-8 space-y-4 text-lg text-gray-575">
							We have partnered with CarClarity to make car
							finance simple. Now you can shop, compare and
							finance quality used cars, new cars and demonstrator
							cars, all online. You can collect it from one of our
							offices in Brisbane, Melbourne or Sydney.
						</div>
						<div class="mt-8 space-y-4 text-lg text-gray-575">
							It’s easiest, most convenient way to shop for a
							quality used or new car in Australia.
						</div>
						<CarClarityCalculators id="car_clarity_widget_2" />
					</div>
				</template>
				<template #image>
					<CarbarImage
						image="img/finance/img-finance_lenders.webp"
						class="mt-10 lg:mt-0"
						alt-text="Finance lenders"
					/>
				</template>
			</ImageAndContent>
		</ContainedSection>

		<ContainedSection id="what-is-car-subscription" :has-background="true">
			<HowFinanceWorks />
		</ContainedSection>

		<ContainedSection
			id="car-subscription-for-business"
			:has-background="true"
		>
			<ImageAndContent>
				<template #content>
					<div class="">
						<h2 class="text-left text-2xl lg:text-5xl">
							Finance your new car - Featured new cars
						</h2>
						<p class="mt-8 text-lg text-gray-575">
							We know that buying a brand new car can be
							stressful, let alone thinking about buying a car on
							finance. With carbarConcierge, we do the heavy
							lifting for you so the process is simple and
							hassle-free.
						</p>
						<p class="mt-8 text-lg text-gray-575">
							The best part is, you can find your dream car and
							get the perfect car finance deal without even having
							to leave your couch.
						</p>
					</div>
					<CarbarLink
						:href="`/buying-a-car/buying-a-new-car`"
						:underline="false"
					>
						<CarbarButton class="mt-8" :is-full-width="false">
							Get deals
						</CarbarButton>
					</CarbarLink>
				</template>
				<template #image>
					<div class="mt-10 w-full lg:mt-0">
						<CarbarImage
							image="img/car-finance/img-newcars.webp"
							alt-text="New cars"
						/>
					</div>
				</template>
			</ImageAndContent>
		</ContainedSection>

		<ContainedSection>
			<CarFinanceFaqs />
		</ContainedSection>
	</div>
</template>

<script setup>
import ImageAndContent from '@/components/sections/ImageAndContent.vue'
import TickList from '@/components/lists/TickList.vue'
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarClarityCalculators from '@/components/modals/carClarity/CarClarityCalculators.vue'
import HowFinanceWorks from '@/components/car-finance/HowFinanceWorks.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarFinanceFaqs from '@/components/car-finance/CarFinanceFaqs.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import HeroSection from '@/components/sections/HeroSection.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'

const crumbs = [
	{
		title: 'Home',
		url: '/',
	},
	{
		title: 'Car finance',
	},
]

const financingItems = [
	{
		label: 'Compare 30+ matched lenders in 60 seconds',
	},
	{
		label: 'Get expert help throughout the application process',
	},
	{
		label: 'No impact on your credit score',
	},
]

useHead(() => ({
	title: 'Compare & Apply for Car Finance Online | carbar Australia',
	meta: [
		{
			name: 'description',
			content:
				'carbar gives you access to some of the most reputable car finance lenders in Australia. Calculate repayments, get expert help & apply online. Learn how.',
		},
	],
}))
</script>
